import React, { useState, useRef } from 'react';
import { API_BASE_URL } from '../../config';
import { withRouter } from "react-router-dom";
import PageWrapper from '../PageWrapper'
import routes from '../Routes'
import { connect } from 'react-redux'
import 'react-toastify/dist/ReactToastify.css';
import Message from '../AlertComponent/Message'
import ForgetPassword from '../AlertComponent/ForgetPassword'

function LoginForm(props) {

    const redirectToHome = () => {

        props.history.push(routes.home);
    }
    (props.loginData) && props.history.push("/");


    const email = useRef(null)
    const pass = useRef(null)
    const [state, setState] = useState({
        email: "",
        password: "",
        successMessage: null,
        error: { name: '', message: '' }, loader: false, success: false, checked: false, successeres: ''
    })
    const [show, setShow] = useState(false);
    const [Forget, setForget] = useState(false)
    //  const handleClose = () => setShow(false);


    const handleChange = (e) => {
        setState(prevState => ({
            ...prevState,
            error: { name: '', message: '' }, successeres: ''
        }))
        const { name, value } = e.target
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))

    }

    const handleSubmitClick = (e) => {
        e.preventDefault();

        if (/^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/.test(state.email)) {
            if (state.password !== "" && state.password.length >= 6) {
                setState((prev) => ({
                    ...prev, loader: true, successeres: ''
                }))

                var data = new FormData();
                data.append("action", "user_login")
                data.append("user_name", state.email)
                data.append("password", state.password)
                //  console.log(data, "data")
                const requestOptions = {
                    method: 'post',
                    body: data
                };

                fetch(API_BASE_URL + 'data_process.php', requestOptions)
                    .then((response) => response.json())
                    .then(async (responseJson) => {


                        if (responseJson.success === "true") {

                            //console.log(state.checked)
                            await setState((prev) => ({
                                ...prev, success: true,
                            }))
                            localStorage.setItem('login', JSON.stringify(responseJson));
                            // if(state.checked){
                            //     localStorage.setItem('login',JSON.stringify(responseJson));
                            // }
                            setTimeout(
                                async () => {
                                    await props.login(responseJson)
                                    setShow(false)
                                    redirectToHome();
                                },
                                1000
                            );
                        }
                        await setState((prev) => ({
                            ...prev, loader: false, successeres: responseJson,
                        }))
                        await setShow(true)

                    })
                    .catch((error) => {
                        setState((prev) => ({
                            ...prev, loader: false,
                        }))
                    });
            } else {
                setState(prevState => ({
                    ...prevState,
                    error: { name: 'pass', message: "password must be 6 characters in length or longer" }
                }))
                pass.current.focus();
                // props.showError("");
            }
        } else {
            setState(prevState => ({
                ...prevState,
                error: { name: 'email', message: "Please enter valid email" }
            }))
            email.current.focus();
            //props.showError("");
        }
    }

    const redirectToRegister = () => {
        props.history.push(routes.signup);
        //props.updateTitle('Register');
    }

    return (
        <PageWrapper title={"login"} isLogin={false}>

            {/* {     <div className="inner_pages">
       
                <div className="container">
                    <div className="mdc-title">
                        <h2>Login</h2>
                    </div>
                    <Message show={show} handleClose={()=>setShow(false)} message={state.successeres}></Message>
                    <ForgetPassword show={Forget} handleClose={()=>setForget(false)} handleResponce={async(data)=>{await setForget(false);

                    await setState((prev)=>({...prev,successeres:data}));
                    setShow(true)
                     }}></ForgetPassword>
                  
                </div>
               
                <div className="form_wrapper" style={{width: "100%",maxWidth: "800px"}}>
                    <div className="form_container">
                      
                   
                        <form>
                            
                            <div className="input_field">
                                        <label className="txt_title">Email*</label>
                                        <input type="email" name="email" value={state.email}
                                    onChange={handleChange} ref={email}/>
                                        <p className={"errormessage"}>{state.error.name === "email" && state.error.message}</p>
                                    </div>
                                    <div className="input_field">
                                        <label className="txt_title">Password*</label>
                                        <input type="password" name="password" value={state.password}
                                    onChange={handleChange} ref={pass} />
                                      <p className={"errormessage"}>{state.error.name === "pass" && state.error.message}</p>
                                    </div>
                            
                         
                            <div className="keep_forget">
                             
                                <div className="forget_pwd"><a onClick={()=>setForget(true)}>Forget Password ?</a></div>
                            </div>

                        
                            <div className="input_btn">
                            <input className="button" type="submit" value="Login" onClick={handleSubmitClick} disabled={state.loader} style={{ opacity: state.loader ? 0.5 : 1 }} /></div>
                            <div className="not_acoount">
                                <p>Don't have an account ?</p>
                                <a onClick={redirectToRegister}>Sign Up</a>
                            </div>
                        </form> 
                    </div>
                </div>
            </div>} */}
            <div className="login_page inner_pages_box w-left">
                <div className="inner_pages mb">
                    <div className="container">
                        <div className="mdc-title">
                            <h3>Login<span>Login</span></h3>
                        </div>
                    </div>
                    <Message show={show} handleClose={() => setShow(false)} message={state.successeres}></Message>
                    <ForgetPassword show={Forget} handleClose={() => setForget(false)} handleResponce={async (data) => {
                        await setForget(false);

                        await setState((prev) => ({ ...prev, successeres: data }));
                        setShow(true)
                    }}></ForgetPassword>
                    <div className="form_wrapper">
                        <div className="form_container">
                            <form>
                                <div className="input_field">
                                    <span role="img" aria-label="user" className="anticon anticon-user">
                                        <svg viewBox="64 64 896 896" focusable="false" data-icon="user" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                            <path d="M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z" />
                                        </svg>
                                    </span>
                                    <input type="email" name="email" value={state.email} onChange={handleChange} ref={email} />
                                    <p className={"errormessage"}>{state.error.name === "email" && state.error.message}</p>
                                </div>
                                <div className="input_field">
                                    <span>
                                        <span role="img" aria-label="unlock" className="anticon anticon-unlock">
                                            <svg viewBox="64 64 896 896" focusable="false" data-icon="unlock" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                                <path d="M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z" />
                                            </svg>
                                        </span>
                                    </span>
                                    <input type="password" name="password" value={state.password}
                                        onChange={handleChange} ref={pass} />
                                    <p className={"errormessage"}>{state.error.name === "pass" && state.error.message}</p>
                                </div>
                                <div className="keep_forget">

                                    <div className="forget_pwd"><a onClick={() => setForget(true)}>Forgot Password ?</a></div>
                                </div>
                                <div className="error-message"><span /></div>
                                <div className="siteBtn_box"><input className="button" type="submit" value="Login" onClick={handleSubmitClick} disabled={state.loader} style={{ opacity: state.loader ? 0.5 : 1 }} /></div>
                                <div className="not_acoount">
                                    <p>Don't have an account ?</p>
                                    <a onClick={redirectToRegister}>Sign Up</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </PageWrapper>
    )
}
const mapStateToProps = (state) => {

    return {
        loginData: state.list.login
    };
};
const mapDispatchToProps = (dispatch) => {
    return {

        login: (data) => dispatch({ type: "LOGIN_INFO", payload: data })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginForm));
//export default withRouter(LoginForm);